
define('modules/application/wizard/classes/probes',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"
],

function(app, Backbone, genericElement) {

  var probesEventAggregator = _.extend({}, Backbone.Events);
  var probes                = _.extend({}, genericElement, {

    Views : {

      titleBar  : genericElement.Views.titleBar.extend({
        template          : "application/wizard/sections/probes/titleBar",
        tagName           : "h3",
        eventAggregator   : probesEventAggregator,

        initialize                    : function() {
          var that = this;

          this.model.unbind("updateViews", this.setLabel);
          this.model.bind("updateViews", this.setLabel, this);

          this.model.titleBarView = this;
        },

        setLabel                      : function() {
          var masterProbeName     = $.i18n._(this.model.get("packageClassLabel"));
          if (masterProbeName!=="")
          {
            var numberOfSlaveProbes = this.model.get("slaveProbes");

            if (numberOfSlaveProbes==1)
              masterProbeName += " + "+numberOfSlaveProbes+" "+$.i18n._("IDS_WTR1_204").toLowerCase();
            else if (numberOfSlaveProbes>1)
              masterProbeName += " + "+numberOfSlaveProbes+" "+$.i18n._("IDS_WTR1_204").toLowerCase();

            this.$el.find(".caption").html(masterProbeName);
            this.$el.find(".caption").fadeIn(200);
          }
          else
            this.$el.find(".caption").fadeOut(200, function() {$(this).hide();});
        },

        removeLabel                   : function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        }
      }),

      content   : genericElement.Views.content.extend({
        template          : "application/wizard/sections/probes/content",
        className         : "probes",
        eventAggregator   : probesEventAggregator,

        events            : {
          "change #probes"                    :  "probesChanged",
          "click .ui-spinner-up"              :  "incrementButtonClicked",
          "click .ui-spinner-down"            :  "decrementButtonClicked",
          "click .toggleMasterProbeInfoButton": "toggleMasterProbeInfos",
          "click .toggleSlaveProbeInfoButton" : "toggleSlaveProbeInfos"
        },

        serialize                      : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        initialize                     : function() {
          this.model.set("view",this);

          this.eventAggregator.unbind("view:enable",this.enableSection);
          this.eventAggregator.bind("view:enable",this.enableSection, this);

          this.eventAggregator.unbind("view:disable",this.disableSection);
          this.eventAggregator.bind("view:disable",this.disableSection, this);


          this.model.unbind("updateViews", this.updateSlaveProbeCounter);
          this.model.bind("updateViews", this.updateSlaveProbeCounter, this);

          this.model.unbind("change:useMainControlUnitAsMasterProbe", this.useMainControlUnitAsMasterProbeChangedEventHandler);
          this.model.bind("change:useMainControlUnitAsMasterProbe",   this.useMainControlUnitAsMasterProbeChangedEventHandler, this);

          this.model.unbind("request:populateMasterProbesDropDown", this.populateMasterProbesDropDown);
          this.model.bind("request:populateMasterProbesDropDown",   this.populateMasterProbesDropDown, this);

          this.render();
        },

        toggleMasterProbeInfos : function(e) {
          e.preventDefault();
          this.toggleInfos("masterProbe");
          return false;
        },

        toggleSlaveProbeInfos : function(e) {
          e.preventDefault();
          this.toggleInfos("slaveProbe");
          return false;
        },

        toggleInfos                            : function(sectionToClose) {
          var that       = this,
              tagClass   = "."+sectionToClose+"Tooltip",
              buttonClass= ".toggle" + sectionToClose.charAt(0).toUpperCase()+sectionToClose.slice(1) + "InfoButton";

          if (window.isBrowserCompatibleWithAnimation())
              that.$el.find(buttonClass + " .arrow-info").transition({ rotate: "+=180" });
          else
          {
            if (this.$el.find(buttonClass + " .tooltip:visible").length>0)
              that.$el.find(buttonClass + " .arrow-info").attr("src", "/assets/img/info-arrow-down.png");
            else
              that.$el.find(buttonClass + " .arrow-info").attr("src", "/assets/img/info-arrow-up.png");
          }

          if (this.$el.find(tagClass+":visible").length===0)
            that.$el.find(tagClass + " hr").toggle();

          this.$el.find(tagClass).slideToggle(function() {if (that.$el.find(tagClass+":visible").length===0) that.$el.find(tagClass + " hr").toggle();});
        },

        useMainControlUnitAsMasterProbeChangedEventHandler : function() {
          if (!this.model.get("useMainControlUnitAsMasterProbe")) {
            this.hideDetails();
          }
          this.model.removeValues();
          this.model.fetchProbes();
          if (this.model.get("useMainControlUnitAsMasterProbe"))
            this.probesChanged();

          this.model.trigger("probes:changed");
        },

        disableSection                 : function(force) {
          if (!this.model.get("enabled")||((force!==undefined)&&(force===true)))
          {
            this.$el.find("select#probes").removeAttr("rel");
            this.$el.find("select#probes option").removeAttr("selected");
            $(this.$el.find("select#probes option")[0]).attr("selected", "selected");
            this.$el.find("select#probes").attr("disabled","disabled");
            this.$el.find("span#selectprobes").remove();

            this.$el.find("masterExampleImage").attr("src","");
            this.$el.find(".description").html("");
            this.$el.find(".linkContainer").html("");
            this.disableSlaveProbes();
            window.customizeFormElements.call();
            this.hideDetails();
          }
        },

        enableSection                  : function() {
          if (this.model.get("enabled"))
          {
            this.$el.find("select#probes").removeAttr("disabled");
            this.$el.find("span#selectprobes").removeClass("disabled");
          }
        },

        hideDetails                    : function() {
          this.$el.find(".masterImage").fadeOut(200,              function() {$(this).hide();});
          this.$el.find(".masterImage").attr("src","");

          this.$el.find(".masterProductCode").fadeOut(200,        function() {$(this).hide();});
          this.$el.find(".masterProductCode").text("");

          this.$el.find(".masterProductDescription").fadeOut(200, function() {$(this).hide();});
          this.$el.find(".masterProductDescription").text("");

          this.$el.find(".slaveImage").fadeOut(200,               function() {$(this).hide();});
          this.$el.find(".slaveImage").attr("src","");

          this.$el.find(".slaveProductCode").fadeOut(200,         function() {$(this).hide();});
          this.$el.find(".slaveProductCode").text("");

          this.$el.find(".slaveProductDescription").fadeOut(200,  function() {$(this).hide();});
          this.$el.find(".slaveProductDescription").text("");
        },

        populateMasterProbesDropDown               : function(Probes) {
          var fetchedMasterProbes;

          if (!Probes)
            fetchedMasterProbes = this.model.fetchedMasterProbes;
          else
            fetchedMasterProbes = this.model.fetchedMasterProbes;

          var dropDownView = this.$el.find("select#probes");
          if ((!this.model.get("packageClassId"))||(this.model.get("packageClassId")===""))
            dropDownView.children("option:first").attr("selected", "selected");

          dropDownView.children("option:not(:first)").remove();

          for (var i=0; i<fetchedMasterProbes.length;i++)
          {
            var selection=(fetchedMasterProbes[i].packageClassId===this.model.get("packageClassId"))?("selected='selected'"):"";
            dropDownView.append("<option value=\""+fetchedMasterProbes[i].packageClassId+"\""+selection+">"+$.i18n._(fetchedMasterProbes[i].packageClassLabel)+"</option>");
          }
        },

        enableSlaveProbes              : function(){
          this.$el.find(".spinner").removeClass("disabled");
          this.$el.find(".ui-spinner-down").removeClass("disabled");
          this.$el.find(".ui-spinner-up").removeClass("disabled");
        },

        disableSlaveProbes             : function() {
          this.$el.find(".spinner").addClass("disabled");
          this.$el.find(".ui-spinner-down").addClass("disabled");
          this.$el.find(".ui-spinner-up").addClass("disabled");

          this.$el.find("#slaveProbesNumber").text(0);
        },

        probesChanged                  : function(event) {
          this.model.set("naturalHideDone", true);
          var probesId;

          if (!this.model.get("useMainControlUnitAsMasterProbe"))
            //If no main control unit is selected set the model's id to UNDEFINED
            probesId      = $(event.target).val()==="" ? undefined : $(event.target).val();
          else
            probesId      = "2012";

          var selectedProbe = _.filter(this.model.fetchedMasterProbes, function(probe){
            return probe.packageClassId==probesId;
          });

          if (selectedProbe.length===1)
          {
            this.model.set("packageClassId",probesId);
            _.extend(this.model.attributes,selectedProbe[0]);

            if (selectedProbe[0].specialVars.minSlaveProbes)
              this.model.set("minSlaveProbes", selectedProbe[0].specialVars.minSlaveProbes);
            else
              this.model.set("minSlaveProbes", 0);
          }
          else
            this.model.set("packageClassId",undefined);

          this.model.resetSlaveProbes();
          this.render();
        },

        setMasterDetails                     : function(id)         {
          this.hideMasterDetails();
          this.showLoader("master");
          this.$el.find(".masterImage").attr("src","/images/"+(this.model.get("image") ? this.model.get("image") : "no-preview.jpg"));
          this.$el.find(".masterProductCode").html(this.model.get("productCode"));

          if ((this.model.get("packageClassDescription"))&&($.i18n._(this.model.get("packageClassDescription")).length>360))
          {
            this.$el.find(".masterProductDescription").text($.i18n._(this.model.get("packageClassDescription")).substring(0, 360));
            this.$el.find(".masterProductDescription").append("<br /><br /><span class='tooltip'>"+$.i18n._("IDS_W1_9032")+" ›</span>");
          }
          else
            this.$el.find(".masterProductDescription").text($.i18n._(this.model.get("packageClassDescription")));

          this.hideLoader("master", this.showMasterDetails);
        },

        setSlaveDetails                     : function(id)         {
          this.hideSlaveDetails();
          this.showLoader("slave");

          if (this.model.get("slaveProbesDetails"))
          {
            this.$el.find(".slaveImage").attr("src","/images/"+( this.model.get('slaveProbesDetails').image ? this.model.get('slaveProbesDetails').image : "no-preview.jpg"));
            this.$el.find(".slaveProductCode").html(this.model.get("slaveProbesDetails").productCode);
            //this.$el.find(".slavepackageClassDescription").html($.i18n._(this.model.get('slaveProbesDetails').packageClassDescription));
            if ((this.model.get('slaveProbesDetails').packageClassDescription)&&($.i18n._(this.model.get('slaveProbesDetails').packageClassDescription).length>360))
            {
              this.$el.find(".slaveProductDescription").text($.i18n._(this.model.get('slaveProbesDetails').packageClassDescription).substring(0, 360));
              this.$el.find(".slaveProductDescription").append("<br /><br /><span class='tooltip'>"+$.i18n._("IDS_W1_9032")+" ›</span>");
            }
            else
              this.$el.find(".slaveProductDescription").text($.i18n._(this.model.get('slaveProbesDetails').packageClassDescription));
          }
          this.hideLoader("slave", this.showSlaveDetails);
        },

        showMasterDetails                    : function()          {
          this.$el.find(".masterProbe .masterImage")             .fadeIn(200);
          this.$el.find(".masterProbe .masterProductCode")       .fadeIn(200);
          this.$el.find(".masterProbe .masterProductDescription").fadeIn(200);
          this.$el.find(".masterProbe .linkContainer")           .fadeTo(200,1, function()  {$(this).show();});
        },

        hideMasterDetails                    : function()          {
          this.$el.find(".masterImage")                          .fadeOut(200, function()   {$(this).hide();});
          this.$el.find(".masterProbe .masterProductCode")       .fadeOut(200, function()   {$(this).hide();});
          this.$el.find(".masterProbe .masterProductDescription").fadeOut(200, function()   {$(this).hide();});
          this.$el.find(".masterProbe .linkContainer")           .fadeTo(200, 0, function() {$(this).hide();});
        },

        showSlaveDetails                    : function()          {
          this.$el.find(".slaveProbe .slaveImage")               .fadeIn(200);
          this.$el.find(".slaveProbe .slaveProductCode")         .fadeIn(200);
          this.$el.find(".slaveProbe .slaveProductDescription")  .fadeIn(200);
          this.$el.find(".slaveProbe .linkContainer")            .fadeTo(200,1);
        },

        hideSlaveDetails                    : function()          {
          this.$el.find(".slaveImage")                           .fadeOut(200, function()  {$(this).hide();});
          this.$el.find(".slaveProbe .slaveProductCode")         .fadeOut(200, function()  {$(this).hide();});
          this.$el.find(".slaveProbe .slaveProductDescription")  .fadeOut(200, function()  {$(this).hide();});
          this.$el.find(".slaveProbe .linkContainer")            .fadeTo(200,0, function() {$(this).hide();});
        },

        showLoader                    : function(target)          {
          if (target=="master")
            this.$el.find(".master-mini-loader").fadeIn(200);
          else
            this.$el.find(".slave-mini-loader").fadeIn(200);
        },

        hideLoader                    : function(target, callback)          {
          var that = this;

          if (target=="master")
          {
            this.$el.find(".master-mini-loader").fadeOut(200, function() {
              callback.call(that);
            });
          }
          else
          {
            this.$el.find(".slave-mini-loader").fadeOut(200, function() {
              callback.call(that);
            });
          }
        },

        isOpen                         : function()          {
          return this.$el.css("display")=="block";
        },

        incrementButtonClicked        : function()           {
          this.model.incrementSlaveProbes();
        },

        decrementButtonClicked        : function()           {
          this.model.decrementSlaveProbes();
        },

        beforeRender                  : function()           {
          this.$el.find("selected").removeAttr("rel");
        },

        afterRender                   : function() {
          var that = this;

          if (this.model.get("links")!==undefined)
          {
            this.$el.find(".masterProbe .linkContainer").fadeTo(200,1);
            this.$el.find(".slaveProbe .linkContainer").fadeTo(200,1);
          }
          window.customizeFormElements.call();
        },

        updateSlaveProbeCounter                 : function() {
          this.$el.find("#slaveProbesNumber").text(this.model.get("slaveProbes"));
        }
      })
    },

    Model : genericElement.Model.extend({
      defaults                            : {
        enabled                         : false,
        id                              : undefined,
        name                            : undefined,
        image                           : undefined,
        description                     : undefined,
        links                           : undefined,
        fetchedProbes                   : undefined,
        fancoilPresent                  : undefined,
        slaveProbes                     : 0,
        slaveDescription                : undefined,
        slaveProbesDetails              : {},
        minSlaveProbes                  : 0,
        useMainControlUnitAsMasterProbe : false
      },

      eventAggregator                     : probesEventAggregator,

      initialize                          : function() {
        var that = this;

        //Bind on solenoidValve line selection
        this.get("zoneEventAggregator").unbind('solenoidValve:chosen',     this.solenoidValveChosenEventHandler);
        this.get("zoneEventAggregator").bind('solenoidValve:chosen',       this.solenoidValveChosenEventHandler, this);

        this.get("zoneEventAggregator").unbind('solenoidValveType:chosen', this.solenoidValveTypeChosenEventHandler);
        this.get("zoneEventAggregator").bind('solenoidValveType:chosen',   this.solenoidValveTypeChosenEventHandler, this);

        this.get("zoneEventAggregator").unbind('solenoidValve:removed',    this.solenoidValveRemovedEventHandler);
        this.get("zoneEventAggregator").bind('solenoidValve:removed',      this.solenoidValveRemovedEventHandler, this);

        window.BticinoS4B.eventAggregator.bind("currentDeliver:requested",this.deliverCurrent, this);
        
        this.unbind("change:slaveProbes", this.slaveProbesChangedEventHandler);
        this.bind("change:slaveProbes",   this.slaveProbesChangedEventHandler, this);

        this.unbind("change:fancoilPresent", this.fetchProbes);
        this.bind("change:fancoilPresent",   this.fetchProbes, this);

        this.unbind("change:packageClassId", this.idChanged);
        this.bind("change:packageClassId",   this.idChanged);

        if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
          this.fetchProbes();
        }

        if (this.get("useMainControlUnitAsMasterProbe")) {
          this.trigger("change:useMainControlUnitAsMasterProbe");
        }
        else if ((this.get("packageClassId"))&&(this.get("packageClassId")!=="")) {

          var selectedProbe = _.filter(this.fetchedMasterProbes, function(probe){
            return probe.packageClassId==that.get("packageClassId");
          });

          if (selectedProbe.length==1)
            _.extend(this.attributes, selectedProbe[0]);

          this.getPackageDetails(this.get("packageClassId"));
        }
      },

      slaveProbesChangedEventHandler      : function() {
        window.BticinoS4B.eventAggregator.trigger('currentDeliver:requested');
      },
      
      solenoidValveChosenEventHandler     : function() {
        this.set("solenoidValveChosen", true);
        this.enableSection();
        this.trigger("probes:changed");
      },

      solenoidValveTypeChosenEventHandler : function(fancoilPresent, theresOneSolenoidValvesAtLeast) {
        if (this.get("fancoilPresent")!==fancoilPresent)
        {
          this.set("fancoilPresent", fancoilPresent);

          if (!this.get("useMainControlUnitAsMasterProbe")) {
            this.fetchProbes();
            if (!theresOneSolenoidValvesAtLeast)
              this.disableSection();
          }
        }
      },

      solenoidValveRemovedEventHandler    : function() {
        this.set("packageClassId",undefined);
        this.disableSection();
        this.trigger("probes:changed");
      },

      fetchProbes                         : function() {
        var that = this;
        if (!this.get("useMainControlUnitAsMasterProbe")) {

          //Retrieve master probes
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("203", function(data) {
            for (var i = data.packages.length - 1; i >= 0; i--)
              data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

            that.fetchedMasterProbes = data.packages;

            var currentpackageClassid = "-1";
            for (i = 0; i<that.fetchedMasterProbes.length; i++)
            {
              if (currentpackageClassid!==that.fetchedMasterProbes[i].packageClassId)
                currentpackageClassid = that.fetchedMasterProbes[i].packageClassId;
              else
              {
                that.fetchedMasterProbes.splice(i,1);
                i--;
              }
            }

            if (!that.get("fancoilPresent"))
            {
              that.fetchedMasterProbes = _.filter(that.fetchedMasterProbes, function(probe) {
                return ((probe.packageClassId!="2024")&&(probe.packageClassId!="2025")&&(probe.packageClassId!="2026"));
              });
            }

            if (that.get("useMainControlUnitAsMasterProbe")) {
              that.set("enabled", true);
            }
            else {
              if ((that.get("view"))&&(!that.get("useMainControlUnitAsMasterProbe")))
                that.trigger("request:populateMasterProbesDropDown");
            }

          });
        }

        //Retrieve slave probes
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("204", function(data) {
          for (var i = data.packages.length - 1; i >= 0; i--)
            data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

          //Sorting elements by packageClassId
          that.fetchedSlaveProbes = data.packages;

          that.fetchedSlaveProbes.sort(function (a, b) {
            if (parseInt(a.packageClassId, 10) < parseInt(b.packageClassId, 10))
              return -1;

            if (parseInt(a.packageClassId, 10) > parseInt(b.packageClassId, 10))
              return 1;
            return 0;
          });


          var currentpackageClassid = "-1";
          for (i = 0; i<that.fetchedSlaveProbes.length; i++)
          {
            if (currentpackageClassid!==that.fetchedSlaveProbes[i].packageClassId)
              currentpackageClassid = that.fetchedSlaveProbes[i].packageClassId;
            else
            {
              that.fetchedSlaveProbes.splice(i,1);
              i--;
            }

          }

          if (that.fetchedSlaveProbes.length>0)
            that.set("slaveProbesDetails", that.fetchedSlaveProbes[0]);

          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(that.get("slaveProbesDetails").packageClassId, function(data) {
              data.products                 = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var mainProduct               = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
              var secondaryProducts         = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

              mainProduct.secondaryProducts = secondaryProducts;

              that.set("slaveProbesDetails", _.extend(that.get("slaveProbesDetails"),mainProduct));
              if (that.get("slaveProbes")<that.get("minSlaveProbes"))
                that.set("slaveProbes",        that.get("minSlaveProbes"));
            });
          }
        });
      },

      getPackageDetails             : function(packageClassId)  {
        var that = this;
        if ((packageClassId)&&(packageClassId!==""))
          BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
            data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
            var mainProduct       = _.filter(data.products,function(product) {return (product.mnemonic===1);})[0];
            var secondaryProducts = _.filter(data.products,function(product) {return (product.mnemonic!==1);});

            _.extend(that.attributes, mainProduct);
            that.set("secondaryProducts", secondaryProducts);

            return mainProduct;
          });
      },

      idChanged                     : function(e)               {
        if (((this.get("packageClassId"))&&(this.get("packageClassId")!==""))||(this.get("useMainControlUnitAsMasterProbe")))
        {
          this.getPackageDetails(this.get("packageClassId"));
          this.trigger("updateViews");
          this.trigger("probes:changed");
        }
        else
        {
          this.titleBarView.removeLabel();
          this.removeValues();
          this.trigger("probes:removed");
        }
      },

      disableSection                : function()                {
        if (this.get("enabled"))
          this.set("enabled",false);
        this.get("view").disableSection();
      },

      enableSection                 : function()                {
        if (!this.get("enabled"))
          this.set("enabled",true);
        this.get("view").enableSection();
      },

      removeValues                  : function()                {
        this.set("image","");
        this.set("links",undefined);
        this.set("mnemonic","");
        this.set("name","");
        this.set("optionalPackages","");
        this.set("packageActuator","");
        this.set("packageClassId","");
        this.set("packageClassLabel","");
        this.set("packageInDepth","");
        this.set("packageLoad","");
        this.set("productDescription","");
        this.set("price","");
        this.set("productCode","");
        this.set("productInDepth","");
        this.set("productLabel","");
        this.set("packageClassDescription","");
        this.set("packageClassLabel","");
        this.set("packageClassId","");
      },

      decrementSlaveProbes          : function()                {
        if ((this.get("packageClassId"))||this.get("useMainControlUnitAsMasterProbe"))
        {
          if ((this.get("slaveProbes")-1)>=this.get("minSlaveProbes"))
          {
            this.set("slaveProbes", (this.get("slaveProbes")-1));
            this.trigger("updateViews");
          }
          return this.get("value");
        }
        else
          return null;
      },

      incrementSlaveProbes          : function()                {
        if ((this.get("packageClassId"))||this.get("useMainControlUnitAsMasterProbe"))
        {
          if ((this.get("slaveProbes")+1)<=8)
          {
            this.set("slaveProbes", (this.get("slaveProbes")+1));
            this.trigger("updateViews");
          }
          return this.get("value");
        }
        else
          return null;
      },

      resetSlaveProbes              : function()                {
        this.set("slaveProbes", this.get("minSlaveProbes"));
        this.trigger("updateViews");
      },

      deliverCurrent            : function() {
        var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

        if (this.get("specialVars") && consumptionIndicatorModel)
        {
          var useMCUAsMasterProbe       = this.get("useMainControlUnitAsMasterProbe");
          var currentConsumption        = ((!useMCUAsMasterProbe) ? this.get("specialVars").currentConsumption : 0)+
                                          this.get("slaveProbesDetails").specialVars.currentConsumption*this.get("slaveProbes");

          if (currentConsumption<0)
            consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
          else
            consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
        }
      },

      onClose: function(){
        this.get("zoneEventAggregator").unbind('solenoidValve:chosen');
        this.get("zoneEventAggregator").unbind('solenoidValve:removed');
        this.unbind("change:packageClassId");
      }
    })

  });

  // Required, return the module for AMD compliance
  return probes;

});